<template>
  <md-dialog :md-active.sync="showDialog">
    <md-dialog-title class="md-dialog-title-style">{{
      item.description
    }}</md-dialog-title>
    <div class="main-detail">
      <div
        class="row img-detail-container mb-4
			"
      >
        <img :src="`${img}${item.shippingOptionGuid}`" />
      </div>
      <!-- <div
        class="row description-container"
        style="width: 50vw; padding: 10px;"
      >
        <div class="col-12 mb-2">
          <h3 class="desc-title">Description:</h3>
        </div>
        <div class="col-12">
          <p>
            {{ item.description }}
          </p>
        </div>
      </div> -->
    </div>
    <md-dialog-actions>
      <md-button
        class="md-button btn-grey md-theme-default"
        style="height: 36px;"
        @click="showDialog = false"
        >Close</md-button
      >
      <!-- <md-button class="md-primary" @click="showDialog = false">Save</md-button> -->
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "BasketDetailDialog",

  props: {
    item: {
      required: true,
      type: Object,
    },
    img: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    showDialog: true,
  }),

  watch: {
    showDialog() {
      if (!this.showDialog) this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.md-dialog /deep/.md-dialog-container {
  /* width: 50vw; */
}

.img-detail-container {
  width: 77%;
  height: 350px;
  border-radius: 5px;
  /* background-color: gray; */
}

.main-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: auto;
}

.description-container {
  width: 100%;
}

.desc-title {
  display: flex;
  justify-content: center;
}

.md-dialog-title-style {
  margin-bottom: 20px;
  padding: 12px 24px 12px;
  background: var(--app-color-primary);
  color: white;
}
img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 3px;
}
</style>
